import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from 'components/Store';

const BackButton = () => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { clickedOnContentUrl } = state;
  const navigate = useNavigate();
  return (
    <>
      {clickedOnContentUrl && (
        <button
          className='general-button back-content-button blue-text'
          onClick={() => {
            navigate(clickedOnContentUrl);
            dispatch({ type: 'MODIFY_SECTION', parameter: 'clickedOnContentUrl', value: null });
          }}
        >
          <span className='icon-long-arrow-left paragraph-p4 mr-2 pointer'></span>Back
        </button>
      )}
    </>
  );
};

export default BackButton;
